import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { cart as cartRequest } from "./requests/estore";
import createFetchRejection from "./utilities/createFetchRejection";
export var cart = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(apiBase) {
    var response, json;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return cartRequest(apiBase);

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.json();

          case 5:
            json = _context.sent;

            if (!response.ok) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", {
              itemsInCart: json.totalUnitCount || 0,
              userName: json.userName
            });

          case 8:
            return _context.abrupt("return", createFetchRejection(response, json));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function cart(_x) {
    return _ref.apply(this, arguments);
  };
}();